import React from 'react';
import logo from '../static/mini_logo.png';

export default function MiniLogo(props) {
    

  return (
    <img src={logo} {...props} ></img>
  );
}